import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { License } from '../../models/license.model';
import { Observable } from 'rxjs';
import { LicenseService } from '../../services/license.service';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'dialog-license',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogLicenseComponent {
  license$: Observable<License>;
  isDialogVisible: boolean = true;

  constructor(licenseService: LicenseService) {
    this.license$ = licenseService.getStateLicense.pipe(
      filter(
        (license: License | undefined): license is License =>
          license !== undefined
      ),
      tap((license) => {
        if (license.isLicenseValid && license.remainingTime > 0) {
          // Convertir segundos a días (1 día = 86400 segundos)
          const remainingDays = Math.floor(license.remainingTime / 86400);
          // console.log(
          //   '(LICENSE) dialog: ',
          //   license.remainingTime,
          //   'segundos -',
          //   remainingDays,
          //   'días'
          // );

          // Mostrar dialog si está entre 0 y 3 días
          if (remainingDays >= 0 && remainingDays <= 3) {
            this.isDialogVisible = true;
            setTimeout(() => {
              this.isDialogVisible = false;
            }, 60000);
          } else {
            this.isDialogVisible = false;
          }
        } else {
          this.isDialogVisible = false;
        }
      })
    );
  }

  closeDialog() {
    this.isDialogVisible = false;
  }
}
